export const getBackgroundHexColor = project => {
  if (project === 1) return '#ccb092'
  else if (project === 0) return '#fff'
  else if (project === 2) return '#BB6B66'
  else if (project === 3) return '#a1bfb4'
  else if (project === 4) return '#2A4351'
  else return '#ccb092'
}